var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4633 20.5827H6.0277C5.0955 20.5827 4.37853 19.8592 4.50567 19.0482L5.14202 14.9892C5.24684 14.3208 5.89683 13.8236 6.66405 13.8236H7.70664C9.36635 16.4102 11.7455 18.3768 11.7455 18.3768C11.7455 18.3768 14.1433 16.4245 15.8036 13.8236H16.827C17.5948 13.8236 18.2442 14.3215 18.349 14.9892L18.9854 19.0482C19.1125 19.8598 18.3949 20.5827 17.4633 20.5827Z",
    fill: "url(#paint0_linear_456_75446)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7462 3.729C8.64692 3.729 6.1344 6.24058 6.1344 9.33866C6.1344 13.7375 11.7462 18.3762 11.7462 18.3762C11.7462 18.3762 17.3573 13.8063 17.3573 9.33866C17.3573 6.24058 14.8448 3.729 11.7462 3.729Z",
    fill: "url(#paint1_linear_456_75446)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1315 10.7239C13.8967 9.95903 13.8967 8.71895 13.1315 7.95409C12.3664 7.18923 11.1258 7.18923 10.3607 7.95409C9.59556 8.71895 9.59555 9.95903 10.3607 10.7239C11.1258 11.4887 12.3664 11.4887 13.1315 10.7239Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_456_75446",
    x1: 4.49103,
    y1: 17.2033,
    x2: 19,
    y2: 17.2033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_456_75446",
    x1: 5.33495,
    y1: 19.1971,
    x2: 18.9545,
    y2: 17.0728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3704"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorGeo);
export default __webpack_public_path__ + "static/media/color-geo.abc34e8cae02dfa4d49112097667931f.svg";
export { ForwardRef as ReactComponent };